import { render, staticRenderFns } from "./DeviceJoystick.vue?vue&type=template&id=d9b11976&scoped=true&"
import script from "./DeviceJoystick.vue?vue&type=script&lang=ts&"
export * from "./DeviceJoystick.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceJoystick.vue?vue&type=style&index=0&id=d9b11976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b11976",
  null
  
)

export default component.exports